
<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="!clientUserItem">
    <h1 class="content-heading-font">{{ currentItem?.BusinessName ||'Client' }} User #{{clientUserID}}</h1>
    <div class="div-loading">Loading client user...</div>
  </div>
  <div *ngIf="clientUserItem" class="main-page-content-block">
    <button class="btn btn-secondary float-end" type="button" [routerLink]="['/client', client_id, 'Users']"  [disabled]="loading">View list</button>
    
    <h1 class="content-heading-font">{{ currentItem?.BusinessName ||'Client' }} User #{{clientUserItem.ID}} - {{clientUserItem.UserName}}</h1>
    <div class="row">
      <div class="col-6 mb-3">
        <label for="FirstName">First Name</label>
        <input class="form-control" readonly name="FirstName" [ngModel]="clientUserItem?.FirstName" autocomplete="off" placeholder="First Name" />
      </div>

      <div class="col-6 mb-3">
        <label for="LastName">Last Name</label>
        <input class="form-control" readonly name="LastName" [ngModel]="clientUserItem?.LastName" autocomplete="off" placeholder="Last Name" />
      </div>
    </div>
    <div class="row">
      <div class="col-6 mb-3">
        <label for="Username">Username</label>
        <input class="form-control" readonly name="Username" [ngModel]="clientUserItem?.UserName" autocomplete="off" placeholder="Username Name" />
      </div>
      <div class="col-6 mb-3">
        <label for="Email">Email</label>
        <input class="form-control" readonly name="Email" [ngModel]="clientUserItem?.Email" autocomplete="off" placeholder="Email" />
      </div>
    </div>
    <div class="row">
      <div class="col-1 mb-3">
        <div class="form-check">
          <label for="Inactive" class="form-check-label">
            <input type="checkbox" class="form-check-input" readonly name="Inactive" [ngModel]="clientUserItem?.Inactive" autocomplete="off" placeholder="Inactive" />
            Inactive
          </label>
        </div>
      </div>
      <div class="col-1 mb-3">
        <div class=" form-check">
          <label for="Hidden" class="form-check-label">
            <input type="checkbox" class="form-check-input" readonly name="Hidden" [ngModel]="clientUserItem?.Hidden" autocomplete="off" placeholder="Inactive" />
            Hidden
          </label>
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6 mb-3" *ngIf="permissions && clientUserItem && canEditAssignments">
        <label for="UserTypes">Permissions:</label>
        <p-listbox [(ngModel)]="clientUserItem.PermissionIDs"
                    [options]="permissions"
                    optionValue="PermissionID"
                    optionLabel="Permission"
                    [filter]="true"
                    [multiple]="true"
                    [checkbox]="true"
                    [disabled]="loading"
                    styleClass="col "
                    listStyleClass=""
                    [showToggleAll]="false"
                    class="flat-listbox"
                    [virtualScroll]="true" [virtualScrollItemSize]="40">
          <ng-template pTemplate="item" let-permission>
            <div class="flex items-center gap-2 ">
              {{ permission.Category }} - {{permission.Permission}}:
              {{permission.Description}}
            </div>
          </ng-template>
        </p-listbox>
      </div>

      <div class="col-6 mb-3" *ngIf="roles && clientUserItem && canEditAssignments">
        <label for="UserTypes">Roles:</label>

        <p-listbox [(ngModel)]="clientUserItem.UserRoleIDs"
                    [options]="roles"
                    optionLabel="Role"
                    optionValue="RoleID"
                    [filter]="true"
                    [multiple]="true"
                    [checkbox]="true"
                    [disabled]="loading"
                    styleClass="col "
                    listStyleClass=""
                    [showToggleAll]="false"
                    class="flat-listbox"
                    [virtualScroll]="true" [virtualScrollItemSize]="40">
          <ng-template pTemplate="item" let-role>
            <div class="flex items-center gap-2 ">
              {{ role.Role }} - {{role.Description}} {{role.Hidden ? "(Hidden)" : ""}}
            </div>
          </ng-template>
        </p-listbox>

      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <button *ngIf="canEditAssignments" class="btn btn-lg btn-primary" type="button" [disabled]="loading || loadingUser" [class.button-loading]="loading" (click)="save()">Save</button>
        <button class="btn btn-lg btn-secondary ms-2" type="button" [disabled]="loading || loadingUser" [class.button-loading]="loading" (click)="editOnOpto()">Edit on Optomiser</button>
        <button class="btn btn-lg btn-danger ms-2" type="button" [disabled]="loading || loadingUser" [class.button-loading]="loading" (click)="resetPassword()">Reset Password</button>
      </div>
    </div>
  </div>
</div>
